import { render, staticRenderFns } from "./box2.vue?vue&type=template&id=517700a2&scoped=true"
import script from "./box2.vue?vue&type=script&lang=js"
export * from "./box2.vue?vue&type=script&lang=js"
import style0 from "./box2.vue?vue&type=style&index=0&id=517700a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517700a2",
  null
  
)

export default component.exports